import Cookies from 'cookies-js';

import { GRAPH_TOKEN_COOKIE } from 'common/constants/CookieNames';

export function hasToken() {
  return typeof Cookies.get(GRAPH_TOKEN_COOKIE) !== 'undefined';
}
